import { useUserConfigurationsContext } from '@reapit-sales/api-v2'
import { User, Office } from '@reapit-sales/live-support-chat'
import { SYSTEM_TYPE } from './constants'

export const useCurrentUser = (): User | null => {
  const { staffMember, settings } = useUserConfigurationsContext()
  return {
    id: staffMember?.id || '',
    firstName: staffMember?.firstName || '',
    lastName: staffMember?.lastName || '',
    email: staffMember?.email || '',
    role: staffMember?.role || '',
    systemLogin: settings?.system?.abmsId || '',
  }
}

export const useCurrentOffice = (): Office | null => {
  const { staffMember, settings } = useUserConfigurationsContext()
  // To-Do: To be replaced with systemType when its available in the API
  let systemType = ''
  switch (true) {
    case settings?.system?.isBranch:
      systemType = SYSTEM_TYPE.BRANCH_OFFICE
      break
    case settings?.system?.isHeadOffice:
      systemType = SYSTEM_TYPE.HEAD_OFFICE
      break
    case settings?.system?.isMultiOffice:
      systemType = SYSTEM_TYPE.MULTI_OFFICE
      break
    case settings?.system?.isMultiSubOffice:
      systemType = SYSTEM_TYPE.MULTI_SUB_OFFICE
      break
    case settings?.system?.isLite:
      systemType = SYSTEM_TYPE.LITE_OFFICE
      break
    default:
      systemType = SYSTEM_TYPE.SINGLE_OFFICE // Default to 'Single-Office' if no other type matches
      break
  }
  return {
    id: staffMember?.officeId || '',
    name: settings?.system?.name || '',
    systemType: systemType,
    locale: settings?.system?.systemLocale || 'en_AU', // default to 'en_AU' if not available
    additionalTelemetry: '', // Optional, can be used for additional telemetry data
    telemetry2: '', // Optional, can be used for additional telemetry data
  }
}
